import { render, staticRenderFns } from "./m-block-qr-code-promo.vue?vue&type=template&id=b14a54c4&scoped=true&lang=pug"
import script from "./m-block-qr-code-promo.vue?vue&type=script&lang=js"
export * from "./m-block-qr-code-promo.vue?vue&type=script&lang=js"
import style0 from "./m-block-qr-code-promo.vue?vue&type=style&index=0&id=b14a54c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b14a54c4",
  null
  
)

export default component.exports